import 'leaflet/dist/leaflet.css';
import './src/styles/global.css';

import * as L from 'leaflet';
if (typeof window !== 'undefined') {
  window.L = L;
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png').default,
    iconUrl:       require('leaflet/dist/images/marker-icon.png').default,
    shadowUrl:     require('leaflet/dist/images/marker-shadow.png').default,
  });
}

import React from 'react';
import { TenantProvider } from './src/firebase/hooks/useTenant';
import { AppDataProvider } from './src/firebase/AppDataContext';
import { ToastHost } from './src/components/Toast';
import CookieConsent from './src/components/CookieConsent';
import { initPostHog } from './src/analytics/posthog';

// Inizializza PostHog (flag-gated: no-op se GATSBY_POSTHOG_KEY è vuota).
export const onClientEntry = () => { initPostHog(); };

// Wrappa tutta l'app con i provider Firebase (auth + dati Firestore)
// + ToastHost per le notifiche globali (react-hot-toast) + banner cookie.
export const wrapRootElement = ({ element }) => (
  <TenantProvider>
    <AppDataProvider>
      {element}
      <ToastHost />
      <CookieConsent />
    </AppDataProvider>
  </TenantProvider>
);
